<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const pageTitle = computed(() => route.meta.title as string | undefined)
</script>

<template>
  <v-container v-if="pageTitle">
    <h1 class="text-h4 font-display font-weight-bold" data-testid="page-title">{{ pageTitle }}</h1>
  </v-container>
</template>
